export type ConsentActionStatus = 'Granted' | 'Rejected';

// An object to map our in-house ConsentActionStatus to the Google Consent Mode V2 Status
export const ConsentModeStatus = {
  Granted: 'granted',
  Rejected: 'denied',
} as const;

export interface ConsentActionEvent extends CustomEvent {
  detail: {
    vendor: string;
    status: ConsentActionStatus;
  };
}

declare global {
  interface Window {
    __tcfapi: (
      command: String,
      version: number,
      callback: (...parameters: any) => void,
      parameter?: any
    ) => void;
    _sp_: {
      [config: string]: any;
    }
    consentActions: {
      [vendor: string]: ConsentActionStatus;
    };
  }
  interface DocumentEventMap {
    ndConsentAction: ConsentActionEvent;
  }
}
